import tunnel from "tunnel-rat";

export const delTunnel = tunnel();
export const uploadImageTunnel = tunnel();
export const videoErrorTunnel = tunnel();
export const publishSuccessTunnel = tunnel();
